<template>
  <div>
    <!-- 通用分摊 -->
    <el-button-group style="margin-bottom: 2px;">
      <el-button size="mini" @click="del">部分移除</el-button>
      <el-button size="mini" @click="allDel">全部移除</el-button>
    </el-button-group>
    <v-divider></v-divider>
    <el-table ref="multipleTable" :data="tableData" height="500" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection"  width="55"></el-table-column>
      <el-table-column label="收费对象" width="200">
        <template slot-scope="scope">
          <el-button style="margin-left: 3px;" @click="updatesc(scope.$index)">对象</el-button>
          {{scope.row.cname}}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="所在房间" show-overflow-tooltip></el-table-column>
      <el-table-column label="承担比率" width="120">
        <template slot-scope="scope">
          <el-input v-model="tableData[scope.$index].Rate" placeholder="承担比率"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="180">
        <template slot-scope="scope">
          <el-input v-model="tableData[scope.$index].remark" placeholder="备注"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>

  </div>
</template>

<script>
import CommonHelp from "./common/CommonHelp";

export default {
  name:"VirtuallyCurrency",
  // 接受父组件的值
  props: {
    house: String,//房产
    activeName:String,//类型
    setup_list:{}//点击设置的对象
  },
  watch:{
    "house"(){
      if(this.activeName == 'currency'){

      }
    },
    "activeName"(){
      if(this.activeName == 'currency'){

      }
    }
  },
  data () {
    return {
      modal1:false,
      projecta:[],
      tableData: [],

      multipleSelection:[],
      index:'',
      dataList:[],
      pageData: {
        total: 0,
        pageSize: 20,
        page: 1,
      },
    }
  },
  mounted(){
    //点击设置进来加载
    if(this.activeName == 'currency'){
      // console.log(this.activeName);
      // console.log(this.setup_list);
    }
  },
  //事件
  methods: {
    datas(data){
      this.dataList=data;
      this.pageData.total=data.length;
      this.pageChange(1);
    },
    pageChange(page){
      const that=this;
      that.pageData.page=page;
      that.tableData = CommonHelp.getPage(ERP.reJson(that.dataList),that.pageData.page,that.pageData.pageSize);
    },
    //选择客户
    updatesc(index){
      this.index = index;
      this.modal1 = true;
    },
    roomUser(){
      let developer = this.$refs.child.getUser();
      this.dataList[this.index].cid = developer.id;
      this.dataList[this.index].cname = developer.name;
      //console.log(developer);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //点击树调用方法
    getTreeUser(tree_str){
      let user_id = this.user_id();
      let data = {'house':tree_str,'pid':this.setup_list.project_id,'user_id':user_id,'name_type':this.setup_list.name_type,'type':1};
      let _this = this;
      ERP.showLoading()
      _this.$myhttp.post('admin/ShareSetup/user',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let data = backdata.data.data;
        data.map(req=>{
          _this.dataList.unshift(req);
        })
        ERP.hideLoading()
      });

    },
    //返回数据
    getUser(){
      return this.user_id();
    },
    //选择的用户筛选出id
    user_id(){
      // console.log(this.tableData);
      return this.dataList
      // return this.tableData.map(req=>{return req.id}).join(',');
    },
    //移除
    del(){
      let that = this;
      let dataList=ERP.reJson(that.dataList);
      let ids=that.multipleSelection.map(ret=>ret.id);
      that.dataList=dataList.filter(ret=>!ids.includes(ret.id))
      that.pageChange(that.pageData.page);
    },
    allDel(){
      const that=this;
      that.tableData = [];
      that.multipleSelection = [];
      that.dataList=[];
    }
  },
  components: {
    "room-user": () => import('../../../../Common/room-user.vue')
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/components/VirtuallyCurrency.vue